<template>
  <v-dialog v-model="autoWeekModel" height="90vh" width="810px">
    <v-overlay :value="loaderOverlay" :absolute="true">
      <v-row justify="center">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-row>
    </v-overlay>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card>
        <v-card-title style="justify-content: center">
          <div align="center">
            <h1 v-if="!saveMode">{{ $t("newAutoWeeklyModel") }}</h1>
            <h1 v-else>{{ $t("editAutoWeeklyModel") }}</h1>
          </div>
        </v-card-title>
        <v-card-text>
          <v-layout class="ma-0 px-0 pt-0 pd-2" justify-space-between row>
            <v-flex grow>
              <v-text-field
                v-model="WeekModel.name"
                :counter="50"
                :label="$t('weeklyModelName')"
                :rules="nameRules"
                :disabled="WeekModel.locked"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-row no-gutters class="d-flex justify-space-around">
            <div class="width: 100px">
              <DatePicker
                :date="WeekModel.validFrom"
                :maxDate="WeekModel.validUntil"
                :label="$t('validFrom')"
                @dateChange="(WeekModel.validFrom = $event), springToUntilDate()"
              ></DatePicker>
            </div>

            <div class="width: 100px">
              <DatePicker
                :date="WeekModel.validUntil"
                :minDate="WeekModel.validFrom"
                :triggerClick="triggerClick"
                :key="counter"
                ref="endDate"
                :label="$t('validUntil')"
                @dateChange="WeekModel.validUntil = $event"
              >
              </DatePicker>
            </div>
          </v-row>
          <v-list dense v-if="WeekModel.validFrom != null && WeekModel.validUntil != null">
            <v-list-group v-for="item in groups" :key="item.id" no-action style="border: 1px solid gray; border-radius: 5px" class="mb-2">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    <div class="d-flex justify-space-between">
                      <h3>
                        {{ $t("excludePeriods") }}
                      </h3>
                    </div>
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item class="pl-2">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-row class="d-flex justify-center" no-gutters v-if="WeekModel.validFrom != null && WeekModel.validUntil != null">
                      <v-data-table
                        :items="WeekModel.exclusionPeriods"
                        :headers="headers"
                        hide-default-footer
                        :items-per-page="100"
                        style="width: 450px"
                        class="elevation-1"
                      >
                        <template v-slot:body="{ items }">
                          <tbody>
                            <tr v-for="(item, index) in items" :key="item.Code" :style="setStyle(item)" @click="selectedLineIndex = index">
                              <td>
                                <v-row justify="end" v-if="item.new" no-gutters>
                                  <v-icon :style="{ cursor: 'pointer' }" @click="addNewExclusionPeriod(index), checkIfExclusionPeriodsOverlap()"
                                    >mdi-plus</v-icon
                                  >
                                </v-row>
                              </td>
                              <td>
                                <v-row justify="center" no-gutters class="d-flex justify-space-around">
                                  <div>
                                    <v-menu ref="exclFromDate" :v-model="startMenu" :close-on-content-click="true" offset-x>
                                      <template v-slot:activator="{ on: menu, attrs }">
                                        <h3 :style="{ cursor: 'pointer' }" v-bind="attrs" v-on="menu">
                                          {{ formattedDate(item.fromDate) }}
                                        </h3>
                                      </template>
                                      <v-card tile>
                                        <v-date-picker
                                          v-model="item.fromDate"
                                          :min="WeekModel.validFrom"
                                          :max="WeekModel.validUntil"
                                          @change="checkIfExclusionPeriodsOverlap(), springToExclUntilDate(index, item)"
                                          @input="timeField = item.fromDate"
                                          :first-day-of-week="1"
                                          scrollable
                                          flat
                                          format="24hr"
                                        ></v-date-picker>
                                      </v-card>
                                    </v-menu>
                                  </div>
                                </v-row>
                              </td>
                              <td>
                                <v-row justify="center" no-gutters class="d-flex justify-space-around">
                                  <div>
                                    <v-menu :v-model="endMenu" :close-on-content-click="true" offset-x>
                                      <template v-slot:activator="{ on: menu, attrs }">
                                        <h3 :style="{ cursor: 'pointer' }" v-bind="attrs" v-on="menu" ref="exclToDate">
                                          {{ formattedDate(item.toDate) }}
                                        </h3>
                                      </template>
                                      <v-card tile>
                                        <v-date-picker
                                          v-model="item.toDate"
                                          @input="timeField = item.toDate"
                                          @change="addNewExclusionPeriod(index), checkIfExclusionPeriodsOverlap()"
                                          :min="WeekModel.validFrom"
                                          :max="WeekModel.validUntil"
                                          :first-day-of-week="1"
                                          scrollable
                                          flat
                                          format="24hr"
                                        ></v-date-picker>
                                      </v-card>
                                    </v-menu>
                                  </div>
                                </v-row>
                              </td>
                              <td>
                                <v-row v-if="!item.new">
                                  <v-icon :style="{ cursor: 'pointer' }" @click="deleteExclusionPeriod(index), checkIfExclusionPeriodsOverlap()"
                                    >mdi-delete</v-icon
                                  >
                                </v-row>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-data-table>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list>

          <v-layout class="ma-0 pa-0" justify-space-between column v-if="WeekModel.validFrom != null && WeekModel.validUntil != null">
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="WeekModel.monday.workTime"
                  :label="$t('monday')"
                  readonly
                  :disabled="WeekModel.locked"
                  style="max-width: 460px"
                  :append-icon="'mdi-pencil'"
                  @click:append="
                    showAutoDailyModel = true;
                    selectedDay = 'monday';
                  "
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-select v-model="WeekModel.monday.type" :items="rhythmTypes" :disabled="WeekModel.locked"></v-select>
              </v-col>
              <v-col cols="4" v-if="WeekModel.monday.type != 0">
                <DatePicker
                  v-if="WeekModel.validFrom != null && WeekModel.validUntil != null"
                  :date="WeekModel.monday.startDate"
                  :key="WeekModel.monday.startDate"
                  :minDate="WeekModel.validFrom"
                  :maxDate="WeekModel.validUntil"
                  :label="$t('firstBookingDate')"
                  :allowedDates="allowedDates"
                  :disabled="WeekModel.locked"
                  @dateChange="WeekModel.monday.startDate = $event"
                  @monthChanged="setAllowedDates(1, WeekModel.monday.type, $event)"
                ></DatePicker>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="WeekModel.tuesday.workTime"
                  :label="$t('tuesday')"
                  readonly
                  :disabled="WeekModel.locked"
                  style="max-width: 460px"
                  :append-icon="'mdi-pencil'"
                  @click:append="
                    showAutoDailyModel = true;
                    selectedDay = 'tuesday';
                  "
                >
                </v-text-field
              ></v-col>
              <v-col cols="4">
                <v-select v-model="WeekModel.tuesday.type" :items="rhythmTypes" :disabled="WeekModel.locked"></v-select>
              </v-col>
              <v-col cols="4" v-if="WeekModel.tuesday.type != 0">
                <DatePicker
                  :date="WeekModel.tuesday.startDate"
                  :key="WeekModel.tuesday.startDate"
                  :minDate="WeekModel.validFrom"
                  :maxDate="WeekModel.validUntil"
                  :label="$t('firstBookingDate')"
                  :allowedDates="allowedDates"
                  :disabled="WeekModel.locked"
                  @dateChange="WeekModel.tuesday.startDate = $event"
                  @monthChanged="setAllowedDates(2, WeekModel.tuesday.type, $event)"
                ></DatePicker>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="WeekModel.wednesday.workTime"
                  :label="$t('wednesday')"
                  readonly
                  :disabled="WeekModel.locked"
                  style="max-width: 460px"
                  :append-icon="'mdi-pencil'"
                  @click:append="
                    showAutoDailyModel = true;
                    selectedDay = 'wednesday';
                  "
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-select v-model="WeekModel.wednesday.type" :items="rhythmTypes" :disabled="WeekModel.locked"></v-select>
              </v-col>
              <v-col cols="4" v-if="WeekModel.wednesday.type != 0">
                <DatePicker
                  :date="WeekModel.wednesday.startDate"
                  :key="WeekModel.wednesday.startDate"
                  :minDate="WeekModel.validFrom"
                  :maxDate="WeekModel.validUntil"
                  :label="$t('firstBookingDate')"
                  :allowedDates="allowedDates"
                  :disabled="WeekModel.locked"
                  @dateChange="WeekModel.wednesday.startDate = $event"
                  @monthChanged="setAllowedDates(3, WeekModel.wednesday.type, $event)"
                ></DatePicker>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="WeekModel.thursday.workTime"
                  :label="$t('thursday')"
                  readonly
                  :disabled="WeekModel.locked"
                  style="max-width: 460px"
                  :append-icon="'mdi-pencil'"
                  @click:append="
                    showAutoDailyModel = true;
                    selectedDay = 'thursday';
                  "
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-select v-model="WeekModel.thursday.type" :items="rhythmTypes" :disabled="WeekModel.locked"></v-select>
              </v-col>
              <v-col cols="4" v-if="WeekModel.thursday.type != 0">
                <DatePicker
                  :date="WeekModel.thursday.startDate"
                  :key="WeekModel.thursday.startDate"
                  :minDate="WeekModel.validFrom"
                  :maxDate="WeekModel.validUntil"
                  :label="$t('firstBookingDate')"
                  :allowedDates="allowedDates"
                  :disabled="WeekModel.locked"
                  @dateChange="WeekModel.thursday.startDate = $event"
                  @monthChanged="setAllowedDates(4, WeekModel.thursday.type, $event)"
                ></DatePicker>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4"
                ><v-text-field
                  v-model="WeekModel.friday.workTime"
                  :label="$t('friday')"
                  readonly
                  :disabled="WeekModel.locked"
                  style="max-width: 460px"
                  :append-icon="'mdi-pencil'"
                  @click:append="
                    showAutoDailyModel = true;
                    selectedDay = 'friday';
                  "
                >
                </v-text-field
              ></v-col>
              <v-col cols="4">
                <v-select v-model="WeekModel.friday.type" :items="rhythmTypes" :disabled="WeekModel.locked"></v-select>
              </v-col>
              <v-col cols="4" v-if="WeekModel.friday.type != 0">
                <DatePicker
                  :date="WeekModel.friday.startDate"
                  :key="WeekModel.friday.startDate"
                  :minDate="WeekModel.validFrom"
                  :maxDate="WeekModel.validUntil"
                  :label="$t('firstBookingDate')"
                  :allowedDates="allowedDates"
                  :disabled="WeekModel.locked"
                  @dateChange="WeekModel.friday.startDate = $event"
                  @monthChanged="setAllowedDates(5, WeekModel.friday.type, $event)"
                ></DatePicker>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="WeekModel.saturday.workTime"
                  :label="$t('saturday')"
                  readonly
                  :disabled="WeekModel.locked"
                  style="max-width: 460px"
                  :append-icon="'mdi-pencil'"
                  @click:append="
                    showAutoDailyModel = true;
                    selectedDay = 'saturday';
                  "
                >
                </v-text-field>
              </v-col>
              <v-col cols="4"> <v-select v-model="WeekModel.saturday.type" :items="rhythmTypes" :disabled="WeekModel.locked"></v-select></v-col>
              <v-col cols="4" v-if="WeekModel.saturday.type != 0">
                <DatePicker
                  :date="WeekModel.saturday.startDate"
                  :key="WeekModel.saturday.startDate"
                  :minDate="WeekModel.validFrom"
                  :maxDate="WeekModel.validUntil"
                  :label="$t('firstBookingDate')"
                  :allowedDates="allowedDates"
                  :disabled="WeekModel.locked"
                  @dateChange="WeekModel.saturday.startDate = $event"
                  @monthChanged="setAllowedDates(6, WeekModel.saturday.type, $event)"
                ></DatePicker>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="WeekModel.sunday.workTime"
                  :label="$t('sunday')"
                  readonly
                  :disabled="WeekModel.locked"
                  style="max-width: 460px"
                  :append-icon="'mdi-pencil'"
                  @click:append="
                    showAutoDailyModel = true;
                    selectedDay = 'sunday';
                  "
                >
                </v-text-field
              ></v-col>
              <v-col cols="4"> <v-select v-model="WeekModel.sunday.type" :items="rhythmTypes" :disabled="WeekModel.locked"></v-select></v-col>
              <v-col cols="4" v-if="WeekModel.sunday.type != 0">
                <DatePicker
                  :date="WeekModel.sunday.startDate"
                  :key="WeekModel.sunday.startDate"
                  :minDate="WeekModel.validFrom"
                  :maxDate="WeekModel.validUntil"
                  :label="$t('firstBookingDate')"
                  :allowedDates="allowedDates"
                  :disabled="WeekModel.locked"
                  @dateChange="WeekModel.sunday.startDate = $event"
                  @monthChanged="setAllowedDates(0, WeekModel.sunday.type, $event)"
                ></DatePicker>
              </v-col>
            </v-row>
          </v-layout>

          <v-textarea
            v-if="WeekModel.validFrom != null && WeekModel.validUntil != null"
            name="input-7-1"
            :label="$t('remark')"
            :counter="254"
            class="pb-2"
            :rules="remarkRules"
            v-model="WeekModel.commit"
          ></v-textarea>

          <v-layout align-center justify-center v-if="WeekModel.validFrom != null && WeekModel.validUntil != null">
            <v-btn v-if="!saveMode" :disabled="logicError" color="primary" @click="addWeekModel">{{ $t("addWeeklyModel") }}</v-btn>
            <v-tooltip v-else bottom color="primary">
              <template slot="activator" slot-scope="{ on }">
                <v-btn v-on="on" v-ripple :disabled="logicError" color="primary" @click="saveWeekModel">{{ $t("saveWeeklyModel") }}</v-btn>
              </template>
              <span class="textColor--text">
                {{ $t("autoModelChangeWarning") }}
              </span>
            </v-tooltip>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-form>
    <AutoDailyModel
      v-if="showAutoDailyModel"
      :dayPeriods="WeekModel[selectedDay].periods"
      @close="showAutoDailyModel = false"
      @addAutoDayModel="addAutoDayModel"
    />
  </v-dialog>
</template>

<script>
export default {
  name: "AutoWeeklyDialog",

  components: { AutoDailyModel: () => import("./AutoDailyModel"), DatePicker: () => import("../DatePicker.vue") },
  data: (vm) => ({
    autoWeekModel: true,
    loaderOverlay: false,
    showAutoDailyModel: false,

    selectedDay: null,

    allowedDates: [],

    nameRules: [(v) => !!v || vm.$t("nameIsRequired"), (v) => v.length <= 50 || vm.$t("maximumCharacterLengthReached")],
    remarkRules: [(v) => v.length <= 254 || vm.$t("maximumCharacterLengthReached")],
    dateRules: [(v) => !!v || vm.$t("nameIsRequired")],
    exclusionPeriods: [],
    timeField: null,
    startMenu: false,
    endMenu: false,
    tableHeader: [],
    groups: [{ id: 1 }],
    valid: true,
    logicError: false,
    triggerClick: false,
    counter: 0
  }),
  props: {
    WeekModel: Object,
    saveMode: Boolean
  },
  computed: {
    headers: function () {
      return [
        {
          align: "center",
          sortable: false,
          value: "actions",
          class: "font-weight-bold title",
          width: "10%"
        },
        {
          text: this.$t("from"),
          align: "center",
          sortable: false,
          value: "fromDate",
          class: "font-weight-bold title",
          width: "40%"
        },
        {
          text: this.$t("until"),
          align: "center",
          sortable: false,
          value: "toDate",
          class: "font-weight-bold title",
          width: "40%"
        },
        {
          align: "center",
          sortable: false,
          class: "font-weight-bold title",
          width: "10%"
        }
      ];
    },
    rhythmTypes: function () {
      return [
        { text: this.$t("everyWeek"), value: 0 },
        { text: this.$t("everySecondWeek"), value: 1 },
        { text: this.$t("everyThirdWeek"), value: 2 },
        { text: this.$t("monthly"), value: 3 }
      ];
    }
  },
  created: function () {
    if (this.saveMode) {
      this.formatFromDate(this.WeekModel.validFrom);
      this.formatUntilDate(this.WeekModel.validUntil);
    }
    this.addExclusionPeriod();
  },
  methods: {
    async addWeekModel() {
      if (this.$refs.form.validate() && this.checkErrors()) {
        this.loaderOverlay = true;
        let index = this.WeekModel.exclusionPeriods.findIndex((item) => item.new);
        this.WeekModel.exclusionPeriods.splice(index, 1);
        await this.$store
          .dispatch("server/timeAccounts/addAutoWeekModel", this.WeekModel)
          .then((resp) => {})
          .catch((err) => {
            console.log(err);
          });
        this.loaderOverlay = false;
        this.autoWeekModel = false;
      }
    },
    async saveWeekModel() {
      if (this.$refs.form.validate() && this.checkErrors()) {
        this.loaderOverlay = true;
        let index = this.WeekModel.exclusionPeriods.findIndex((item) => item.new);
        this.WeekModel.exclusionPeriods.splice(index, 1);
        await this.$store
          .dispatch("server/timeAccounts/saveAutoWeekModel", this.WeekModel)
          .then((resp) => {})
          .catch((err) => {
            console.log(err);
          });
        this.loaderOverlay = false;
        this.autoWeekModel = false;
      }
    },
    checkErrors() {
      if (this.WeekModel.monday.type != 0 && this.$moment(this.WeekModel.monday.startDate).day() != 1) {
        this.showErrorMessage(this.$t("autoModelNextDateError").format(this.$t("monday")));
        return false;
      } else if (this.WeekModel.tuesday.type != 0 && this.$moment(this.WeekModel.tuesday.startDate).day() != 2) {
        this.showErrorMessage(this.$t("autoModelNextDateError").format(this.$t("tuesday")));
        return false;
      } else if (this.WeekModel.wednesday.type != 0 && this.$moment(this.WeekModel.wednesday.startDate).day() != 3) {
        this.showErrorMessage(this.$t("autoModelNextDateError").format(this.$t("wednesday")));
        return false;
      } else if (this.WeekModel.thursday.type != 0 && this.$moment(this.WeekModel.thursday.startDate).day() != 4) {
        this.showErrorMessage(this.$t("autoModelNextDateError").format(this.$t("thursday")));
        return false;
      } else if (this.WeekModel.friday.type != 0 && this.$moment(this.WeekModel.friday.startDate).day() != 5) {
        this.showErrorMessage(this.$t("autoModelNextDateError").format(this.$t("friday")));
        return false;
      } else if (this.WeekModel.saturday.type != 0 && this.$moment(this.WeekModel.saturday.startDate).day() != 6) {
        this.showErrorMessage(this.$t("autoModelNextDateError").format(this.$t("saturday")));
        return false;
      } else if (this.WeekModel.sunday.type != 0 && this.$moment(this.WeekModel.sunday.startDate).day() != 7) {
        this.showErrorMessage(this.$t("autoModelNextDateError").format(this.$t("sunday")));
        return false;
      }
      return true;
    },
    formattedDate(date) {
      return this.$moment(date).format("DD.MM.YYYY");
    },
    addAutoDayModel(dayModel, workTime, pauseTime) {
      this.WeekModel[this.selectedDay].workTime = workTime;
      this.WeekModel[this.selectedDay].pause = pauseTime;
      this.WeekModel[this.selectedDay].periods = dayModel;
    },
    formatFromDate(val) {
      this.formattedFromDate = this.formattedDate(val);
    },
    formatUntilDate(val) {
      this.formattedUntilDate = this.formattedDate(val);
    },
    addExclusionPeriod() {
      if (this.WeekModel.validFrom != null && this.WeekModel.validUntil != null) {
        this.WeekModel.exclusionPeriods.push({
          fromDate: this.$moment(this.WeekModel.validFrom).format("YYYY-MM-DD"),
          toDate: this.$moment(this.WeekModel.validFrom).format("YYYY-MM-DD"),
          id: 0,
          weekModelId: this.WeekModel.id,
          new: true
        });
      }
    },
    addNewExclusionPeriod(index) {
      if (!this.WeekModel.exclusionPeriods[index].new) return;

      this.WeekModel.exclusionPeriods[index].new = false;
      if (this.WeekModel.exclusionPeriods[index].fromDate > this.WeekModel.exclusionPeriods[index].toDate)
        this.WeekModel.exclusionPeriods[index].toDate = this.WeekModel.exclusionPeriods[index].fromDate;
      else if (this.WeekModel.exclusionPeriods[index].toDate < this.WeekModel.exclusionPeriods[index].fromDate)
        this.WeekModel.exclusionPeriods[index].fromDate = this.WeekModel.exclusionPeriods[index].toDate;
      this.addExclusionPeriod();
    },
    deleteExclusionPeriod(index) {
      this.WeekModel.exclusionPeriods.splice(index, 1);
    },
    setStyle(item) {
      if (item.logicError) {
        return "background-color: #EF9A9A";
      }

      if (this.$vuetify && this.$vuetify.theme.dark) {
        return "";
      }

      return "background-color: white";
    },
    checkIfExclusionPeriodsOverlap() {
      let exclusionPeriods = this.WeekModel.exclusionPeriods.filter((item) => item.new == false);
      for (let period of exclusionPeriods) {
        period.logicError = false;
      }

      let index = 0;

      while (index < exclusionPeriods.length) {
        let firstLine = exclusionPeriods[index];
        index++;

        if (this.$moment(firstLine.toDate).isBefore(this.$moment(firstLine.fromDate))) {
          firstLine.logicError = true;
        }

        if (index > exclusionPeriods.length - 1) {
          break;
        }

        let nextLine = exclusionPeriods[index];

        if (this.$moment(firstLine.toDate).isSameOrAfter(this.$moment(nextLine.fromDate))) {
          firstLine.logicError = true;
        }

        if (this.$moment(nextLine.fromDate).isSameOrBefore(this.$moment(firstLine.toDate))) {
          nextLine.logicError = true;
        }
      }

      for (let period of exclusionPeriods) {
        if (period.logicError) {
          this.logicError = true;
          break;
        } else {
          this.logicError = false;
        }
      }
    },
    setNextBookingDate(weekDay) {
      if (weekDay == 0) {
        this.WeekModel.monday.nextDate = this.$moment().day(1).format("YYYY-MM-DD");
      } else if (weekDay == 1) {
        this.WeekModel.tuesday.nextDate = this.$moment().day(2).format("YYYY-MM-DD");
      } else if (weekDay == 2) {
        this.WeekModel.wednesday.nextDate = this.$moment().day(3).format("YYYY-MM-DD");
      } else if (weekDay == 3) {
        this.WeekModel.thursday.nextDate = this.$moment().day(4).format("YYYY-MM-DD");
      } else if (weekDay == 4) {
        this.WeekModel.friday.nextDate = this.$moment().day(5).format("YYYY-MM-DD");
      } else if (weekDay == 5) {
        this.WeekModel.saturday.nextDate = this.$moment().day(6).format("YYYY-MM-DD");
      } else if (weekDay == 6) {
        this.WeekModel.sunday.nextDate = this.$moment().day(-1).format("YYYY-MM-DD");
      }
    },
    setAllowedDates(weekDay, type, date) {
      let allowedDates = [];
      if (type == 0) return [];
      if (date == null) {
        let currentDate = this.WeekModel.validFrom;
        while (currentDate < this.WeekModel.validUntil) {
          currentDate = this.$moment(currentDate).day(weekDay).add(7, "days").format("YYYY-MM-DD");
          if (currentDate > this.WeekModel.validUntil) break;
          allowedDates.push(currentDate);
        }
      } else {
        let currentDate = this.$moment(date, "YYYY-MM").day(weekDay).format("YYYY-MM-DD");
        allowedDates.push(currentDate);
        let index = 0;
        while (index != 5) {
          currentDate = this.$moment(currentDate).day(weekDay).add(7, "days").format("YYYY-MM-DD");
          allowedDates.push(currentDate);
          index++;
        }
      }
      this.allowedDates = allowedDates;
    },
    checkStartDateForEveryDay() {
      let mondayDiff = this.$moment(this.WeekModel.monday.startDate).diff(this.$moment(this.WeekModel.validFrom), "days");
      if (mondayDiff < 0) {
        this.WeekModel.monday.startDate = this.$moment(this.WeekModel.validFrom).day(1).format("YYYY-MM-DD");
        this.WeekModel.monday.startDate = this.addWeekForStartDate(this.WeekModel.monday.startDate, this.WeekModel.validFrom);
      }

      let tuesdayDiff = this.$moment(this.WeekModel.tuesday.startDate).diff(this.$moment(this.WeekModel.validFrom), "days");
      if (tuesdayDiff < 0) {
        this.WeekModel.tuesday.startDate = this.$moment(this.WeekModel.validFrom).day(2).format("YYYY-MM-DD");
        this.WeekModel.tuesday.startDate = this.addWeekForStartDate(this.WeekModel.tuesday.startDate, this.WeekModel.validFrom);
      }

      let wednesdayDiff = this.$moment(this.WeekModel.wednesday.startDate).diff(this.$moment(this.WeekModel.validFrom), "days");
      if (wednesdayDiff < 0) {
        this.WeekModel.wednesday.startDate = this.$moment(this.WeekModel.validFrom).day(3).format("YYYY-MM-DD");
        this.WeekModel.wednesday.startDate = this.addWeekForStartDate(this.WeekModel.wednesday.startDate, this.WeekModel.validFrom);
      }

      let thursdayDiff = this.$moment(this.WeekModel.thursday.startDate).diff(this.$moment(this.WeekModel.validFrom), "days");
      if (thursdayDiff < 0) {
        this.WeekModel.thursday.startDate = this.$moment(this.WeekModel.validFrom).day(4).format("YYYY-MM-DD");
        this.WeekModel.thursday.startDate = this.addWeekForStartDate(this.WeekModel.thursday.startDate, this.WeekModel.validFrom);
      }

      let fridayDiff = this.$moment(this.WeekModel.friday.startDate).diff(this.$moment(this.WeekModel.validFrom), "days");

      if (fridayDiff < 0) {
        this.WeekModel.friday.startDate = this.$moment(this.WeekModel.validFrom).day(5).format("YYYY-MM-DD");
        this.WeekModel.friday.startDate = this.addWeekForStartDate(this.WeekModel.friday.startDate, this.WeekModel.validFrom);
      }

      let saturdayDiff = this.$moment(this.WeekModel.saturday.startDate).diff(this.$moment(this.WeekModel.validFrom), "days");
      if (saturdayDiff < 0) {
        this.WeekModel.saturday.startDate = this.$moment(this.WeekModel.validFrom).day(6).format("YYYY-MM-DD");
        this.WeekModel.saturday.startDate = this.addWeekForStartDate(this.WeekModel.saturday.startDate, this.WeekModel.validFrom);
      }

      let sundayDiff = this.$moment(this.WeekModel.sunday.startDate).diff(this.$moment(this.WeekModel.validFrom), "days");
      if (sundayDiff < 0) {
        this.WeekModel.sunday.startDate = this.$moment(this.WeekModel.validFrom).day(7).format("YYYY-MM-DD");
        this.WeekModel.sunday.startDate = this.addWeekForStartDate(this.WeekModel.sunday.startDate, this.WeekModel.validFrom);
      }
    },
    addWeekForStartDate(startDate, validFrom) {
      let diff = this.$moment(startDate).diff(this.$moment(validFrom), "days");
      if (diff < 0) return this.$moment(startDate).add(1, "weeks").format("YYYY-MM-DD");
      else return startDate;
    },
    showErrorMessage(text) {
      this.$eventHub.$emit("showError", text, "bottom", "right");
    },
    springToUntilDate() {
      this.triggerClick = true;
      this.counter++;
    },
    springToExclUntilDate(index, item) {
      if (item.new == true) this.$refs.exclToDate[index].click();
    }
  },
  beforeDestroy: function () {
    this.$emit("close");
  },
  watch: {
    autoWeekModel(val) {
      if (!val) {
        this.$destroy();
      }
    },
    "WeekModel.validFrom": {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (oldValue == null && this.WeekModel.validUntil != null && !this.saveMode) this.addExclusionPeriod();
        this.checkStartDateForEveryDay();
        //this.setAllowedDates();
      }
    },
    "WeekModel.validUntil": {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (oldValue == null && this.WeekModel.validFrom != null && !this.saveMode) this.addExclusionPeriod();
      }
    },
    "WeekModel.monday.type": {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.setAllowedDates(1, newValue, null);
        if (newValue == 0) {
          this.WeekModel.monday.nextDate = null;
          this.WeekModel.monday.startDate = null;
        }
      }
    },
    "WeekModel.tuesday.type": {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.setAllowedDates(2, newValue, null);
        if (newValue == 0) {
          this.WeekModel.tuesday.nextDate = null;
          this.WeekModel.tuesday.startDate = null;
        }
      }
    },
    "WeekModel.wednesday.type": {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.setAllowedDates(3, newValue, null);
        if (newValue == 0) {
          this.WeekModel.wednesday.nextDate = null;
          this.WeekModel.wednesday.startDate = null;
        }
      }
    },
    "WeekModel.thursday.type": {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.setAllowedDates(4, newValue, null);
        if (newValue == 0) {
          this.WeekModel.thursday.nextDate = null;
          this.WeekModel.thursday.startDate = null;
        }
      }
    },
    "WeekModel.friday.type": {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.setAllowedDates(5, newValue, null);
        if (newValue == 0) {
          this.WeekModel.friday.nextDate = null;
          this.WeekModel.friday.startDate = null;
        }
      }
    },
    "WeekModel.saturday.type": {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.setAllowedDates(6, newValue, null);
        if (newValue == 0) {
          this.WeekModel.saturday.nextDate = null;
          this.WeekModel.saturday.startDate = null;
        }
      }
    },
    "WeekModel.sunday.type": {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.setAllowedDates(7, newValue, null);
        if (newValue == 0) {
          this.WeekModel.sunday.nextDate = null;
          this.WeekModel.sunday.startDate = null;
        }
      }
    }
  }
};
</script>

<style></style>
